/**
 * @return {JSX.Element}
 */
export default function GradientBackground() {
  return (
    <div className="absolute !z-0 w-full h-full pointer-events-none min-h-full overflow-hidden">
      <div className="relative !z-0 w-screen h-screen min-h-screen min-w-max ">
        <svg
          className="fill-current text-blurbackgroundsecondary absolute portrait:h-[750px] portrait:w-[750px] portrait:-top-2 portrait:-right-1 landscape:bottom-0 landscape:left-0 landscape:right-0 landscape:top-0"
          viewBox="0 0 1080 720"
        >
          <defs>
            <radialGradient id="gradientOne">
              <stop offset="0%" stopColor="currentColor" />
              <stop offset="95%" stopColor="currentColor" stopOpacity="0%" />
            </radialGradient>
          </defs>
          <ellipse
            className=" gradient-backdrop-blur fill-[url('#gradientOne')]"
            cx="950"
            cy="365"
            rx="403"
            ry="365"
            fillOpacity="0.5"
          />
        </svg>
        <svg
          viewBox="0 0 1080 720"
          className="fill-current text-blurbackgroundthree absolute  portrait:-left-2/3 portrait:h-[100vh] portrait:w-[100vh] landscape:bottom-0 landscape:left-0 landscape:right-0 landscape:top-0"
        >
          <defs>
            <radialGradient id="gradientTwo">
              <stop offset="0%" stopColor="currentColor" />
              <stop offset="95%" stopColor="currentColor" stopOpacity="0%" />
            </radialGradient>
          </defs>
          <ellipse
            className="gradient-backdrop-blur fill-[url('#gradientTwo')]"
            cx="560"
            cy="383"
            rx="390"
            ry="341"
            fillOpacity="0.5"
          />
        </svg>
        <svg
          viewBox="0 0 1080 720"
          className="absolute fill-current text-blurbackgroundprimary portrait:w-[250vw] portrait:-left-1/3 portrait:top-5 landscape:bottom-0 landscape:left-0 landscape:right-0 landscape:top-0"
        >
          <defs>
            <radialGradient id="gradientThree">
              <stop offset="0%" stopColor="currentColor" />
              <stop offset="95%" stopColor="currentColor" stopOpacity="0%" />
            </radialGradient>
          </defs>
          <ellipse
            className="gradient-backdrop-blur fill-[url('#gradientThree')]"
            cx="200"
            cy="200"
            rx="295"
            ry="256.5"
            fillOpacity="0.5"
          />
        </svg>
      </div>
    </div>
  )
}
